/**
 * Validate that a lat/lon pair is a usable coordinate for map and commute features.
 *
 * Rejects undefined, NaN, Infinity, out-of-range values, and the (0, 0) sentinel
 * which the listing API uses to mean "no geo data".
 */
export const isValidCoordinate = (lat?: number, lon?: number): boolean => {
  return (
    typeof lat === 'number' &&
    typeof lon === 'number' &&
    isFinite(lat) &&
    isFinite(lon) &&
    lat >= -90 &&
    lat <= 90 &&
    lon >= -180 &&
    lon <= 180 &&
    lat !== 0 &&
    lon !== 0
  );
};
